import { FaTimes } from "react-icons/fa";
import { useAppContextProvider } from '../../contextapi';
import { CommentTab, TrackChanges } from "../rightsidecontent";
import { useState, useEffect, useRef } from "react";

const TrackChangeandComment = (props) => {
    const [trackChangeData, setTrackchangeData] = useState([]);
    const [commentsAll, setCommentsAll] = useState([]);
    const [tabValue, setTabValue] = useState('comments');
    const { setSidebarClose, trackChanges, commentValue } = useAppContextProvider();
    const closeBtnRef = useRef(null);

    const tabHandel = (type) => {
        setTabValue(type);
    };

    const getTrigger = (value) => {
        props.getTrigger(value);
    };

    useEffect(() => {
        if (trackChanges?.length !== 0) {
            setTrackchangeData(trackChanges)
        } else {
            setTrackchangeData([])
        }
        if (commentValue?.comment?.length !== 0) {
            setCommentsAll(commentValue.comment)
        } else {
            setCommentsAll([])
        }
    }, [trackChanges,commentValue])

  useEffect(() => {
    // Focus the close button when Author Query tab is opened
    if (closeBtnRef.current) {
      closeBtnRef.current.focus();
    }
  }, [closeBtnRef]);

    return (
        <aside className="comment-area trakandcommentTab" aria-label="Editor Logs">
            <div className="slider-header">
                <h2>Editor Logs</h2>
               <button
                        className="close-btn"
                        title="Close"
                              tabIndex={0}
                        ref={closeBtnRef}
                        onClick={() => {
                          setSidebarClose(true);
                          setTimeout(() => {
                            // Focus the Track Changes and Comment tab button in the sidebar
                            const logFilesTabBtn = document.querySelector(
                              'button[title="Track Changes and Comment tab"]'
                            );
                            if (logFilesTabBtn) logFilesTabBtn.focus();
                          }, 0);
                        }}
                        onKeyDown={(e) => {
                        if (e.key === "Tab" && !e.shiftKey) {
                            e.preventDefault();
                            setTimeout(() => {
                            const tabBtns = document.querySelectorAll('.trackandcommenttab .tab-header button');
                            if (tabBtns.length > 0) tabBtns[0].focus(); // Focus Comments tab
                            }, 0);
                        }
                        }}>
                        <FaTimes />
                      </button>
            </div>
            <div className="trackandcommenttab">
                <div className="tab-header">
                    <button title="Comments" onClick={() => tabHandel('comments')} className={tabValue === "comments" ? 'active' : ''} tabIndex={0}>Comment - ({commentsAll?.length})</button>
                    <button title="Track changes" onClick={() => tabHandel('trackchanges')} className={tabValue === "trackchanges" ? 'active' : ''} tabIndex={0}>Track Changes - ({trackChangeData?.length})</button>
                </div>
                <div className="tab-inner">
                    {tabValue === "comments" ? <CommentTab getTrigger={getTrigger} /> : tabValue === "trackchanges" ?
                        < TrackChanges getTrigger={getTrigger} /> : ""}
                </div>
            </div>
        </aside>
    )
}
export default TrackChangeandComment;